// Helper to extract YouTube video ID from various URL forms
export const youtubeId = (url) => {
  if (!url) return null;
  try {
    const patterns = [
      /youtube\.com\/watch\?v=([^&]+)/,
      /youtu\.be\/([^?&/]+)/,
      /youtube\.com\/embed\/([^?&/]+)/,
      /youtube\.com\/shorts\/([^?&/]+)/,
    ];
    for (const p of patterns) {
      const m = url.match(p);
      if (m) return m[1];
    }
  } catch (_e) { /* ignore */ }
  return null;
};

export const youtubeThumb = (url) => {
  const id = youtubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};
